import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dialog, DialogProps, DialogTitle, DialogContent, Grid, TextField, Box, Button, DialogActions } from "@mui/material";
import { OnSaveContentFilterParameters } from "../ContentFilterTable";
import "./ContentFilterDialog.css";
import close from "../../../asset/image/close.svg";
import ContentFilterBasicDetails from "../ContentFilterBasicDetails";
import ContentFilterBlockedCategories from "../ContentFilterBlockedCategories";
import ContentFilterAllowedDomains from "../ContentFilterAllowedDomains";
import ContentFilterBlockedDomains from "../ContentFilterBlockedDomains";
import {ContentFilter, Category, Domain} from "./../../../UserScreen/CustomContentFilter/types"
import _ from "lodash"
import { toast } from "react-toastify";

const NavBar = ({ items, selectedItem, onSelect }) => {
    return (
        <div className="content-filter-nav-bar">
            <ul>
                {items.map((item, index) => (
                    <li
                        key={index}
                        className={item === selectedItem ? "content-filter-nav-item selected": "content-filter-nav-item" }
                        onClick={() => onSelect(item)}
                    >
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
};

interface ContentFilterDialogType {
    authReducer:any,
    errorReducer:any,
    open:any,
    onClose: ()=>{},
    contentFilterToUpdate: ContentFilter,
    onSave:(OnSaveContentFilterParameters)=>{},
    createContentFilterData: any,
    updateContentFilterData: any
}
function CreateContentFilterDialog({authReducer, errorReducer, open, onClose, contentFilterToUpdate, onSave, createContentFilterData, updateContentFilterData }:ContentFilterDialogType) {
    
    const configItems = ['BASIC DETAILS', 'BLOCKED CATEGORIES', 'ALLOWED DOMAINS', 'BLOCKED DOMAINS'];

    const [scroll, setScroll] = useState<DialogProps['scroll']>('paper');
    const [selectedConfig, setSelectedConfig] = useState('BASIC DETAILS');
    const [contentFilterName, setContentFilterName] = useState<string>("");
    const [contentFilterComment, setContentFilterComment] = useState<string>("");
    const [blockedCategories, setBlockedCategories] = useState<Category[]>([]);
    const [allowedDomains, setAllowedDomains] = useState<Domain[]>([]);
    const [blockedDomains, setBlockedDomains] = useState<Domain[]>([]); 
    const [isEditContentFilter, setEditContentFilter] = useState(false)
    const [contentFilterId, setContentFilterId] = useState<string>("")
    const [defaultCF, setDefaultCF] = useState<boolean>(false);
    const [allowedfileSelected, setAllowedFileSelected] = useState<boolean>(false)
    const [allowedFileName, setAllowedFileName] = useState<string>("")
    const [csvFileAllowedDomains, setCSVFileAllowedDomains] = useState<Domain[]>([])
    const [blockedfileSelected, setBlockedFileSelected] = useState<boolean>(false)
    const [blockedFileName, setBlockedFileName] = useState<string>("")
    const [csvFileBlockedDomains, setCSVFileBlockedDomains] = useState<Domain[]>([])

    useEffect(()=>{
        if(!open){
            setEditContentFilter(false)
        }
    }, [open])

    useEffect(()=>{
        if(!_.isEmpty(contentFilterToUpdate)) {
            setContentFilterName(contentFilterToUpdate?.name)
            setContentFilterComment(contentFilterToUpdate?.description)
            setBlockedCategories(contentFilterToUpdate?.policy?.categories)
            setAllowedDomains(contentFilterToUpdate?.policy?.allowed_domains)
            setBlockedDomains(contentFilterToUpdate?.policy?.blocked_domains)
            setEditContentFilter(true)
            let defaultCf = contentFilterToUpdate?.default || false
            setDefaultCF(defaultCf)
        }
    }, [contentFilterToUpdate])

    const onSetContentFilterName = (name)=>{
        setContentFilterName(name)
    }

    const onSetContentFilterComment = (comment)=>{
        setContentFilterComment(comment)
    }

    const onSetBlockedCategories = (data:Category[])=>{
        setBlockedCategories(data)
    }
    
    const onSetAllowedDomains = (data)=>{
        setAllowedDomains(data)
    }
    
    const onSetBlockedDomains = (data)=>{
        setBlockedDomains(data)
    }

    const handleFileUpload = (file, isAllowed) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            let text:any
            text = event?.target?.result;

            let arrData:any = []
            if(text.includes("\r\n")){
                arrData = text?.split("\r\n")
            } else {
                arrData = text?.split("\n")
            }

            let arrDomains = isAllowed ? allowedDomains : blockedDomains
            const csvFileDomains = isAllowed ? csvFileAllowedDomains : csvFileBlockedDomains
            let fileContentError = false
            for(let i=0;i<arrData.length;i++){
                if(i==0){
                    let row = arrData[i].split(",")
                    let column1Heading = row[0]
                    let column2Heading = row[1]

                    if(!(column1Heading == "DOMAIN" && column2Heading == "SUB_DOMAIN")){
                        toast.error("Invalid CSV file format.", {
                            position: toast.POSITION.BOTTOM_LEFT
                        })
                        return
                    }
                    continue
                }

                let row = arrData[i].split(",")
                let domain = row[0]
                let includeSubDomain = row[1]

                if(domain != ""){
                    if(!(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(domain))){
                        fileContentError = true
                        continue
                    }

                    if(!(includeSubDomain.toLowerCase() == "false" || includeSubDomain.toLowerCase() == "true")){
                        fileContentError = true
                        continue
                    }

                    let obj :Domain = {
                        domain: domain,
                        sub_domain: (includeSubDomain.toLowerCase() == "false") ? false : true
                    }
                    const alreadyExists = arrDomains.some(
                        (item) => item.domain.toLowerCase() === obj.domain.toLowerCase()
                    );

                    if (!alreadyExists) {
                        arrDomains.push(obj);
                        csvFileDomains.push(obj);
                    }
                }
            }
            if(isAllowed){
                setAllowedDomains(arrDomains)
                setCSVFileAllowedDomains(csvFileDomains)
                setAllowedFileName(file.name)
                setAllowedFileSelected(true)
            }
            else {
                setBlockedDomains(arrDomains);
                setCSVFileBlockedDomains(csvFileDomains);
                setBlockedFileName(file.name);
                setBlockedFileSelected(true);
            }
            if(fileContentError){
                toast.error("Some rows are skipped due to invalid domain or sub domain values.", {
                    position: toast.POSITION.BOTTOM_LEFT
                })
            }
        };
        reader.readAsText(file);
    };

    const renderConfigForm = () => {
        switch (selectedConfig) {
            case 'BASIC DETAILS':
                return (
                <ContentFilterBasicDetails onSetContentFilterName={onSetContentFilterName} contentFilterName={contentFilterName} onSetContentFilterComment={onSetContentFilterComment} contentFilterComment={contentFilterComment} isEditable={isEditContentFilter}></ContentFilterBasicDetails>
                )
            case 'BLOCKED CATEGORIES':
                return (
                    <ContentFilterBlockedCategories blockedCategoriesProps={blockedCategories} onSetBlockedCategories={onSetBlockedCategories}></ContentFilterBlockedCategories>
                )
            case 'ALLOWED DOMAINS':
                return (
                    <ContentFilterAllowedDomains allowedDomains={allowedDomains} setAllowedDomains={setAllowedDomains} onSetAllowedDomains={onSetAllowedDomains} handleFileUpload={handleFileUpload} allowedfileSelected={allowedfileSelected} setAllowedFileSelected={setAllowedFileSelected} allowedFileName={allowedFileName} setAllowedFileName={setAllowedFileName} csvFileAllowedDomains={csvFileAllowedDomains} setCSVFileAllowedDomains={setCSVFileAllowedDomains}></ContentFilterAllowedDomains>
                )
            case 'BLOCKED DOMAINS':
                return (
                    <ContentFilterBlockedDomains onSetBlockedDomains={onSetBlockedDomains} blockedDomains={blockedDomains} setBlockedDomains={setBlockedDomains} handleFileUpload={handleFileUpload} blockedfileSelected={blockedfileSelected} setBlockedFileSelected={setBlockedFileSelected} blockedFileName={blockedFileName} setBlockedFileName={setBlockedFileName} csvFileBlockedDomains={csvFileBlockedDomains} setCSVFileBlockedDomains={setCSVFileBlockedDomains}></ContentFilterBlockedDomains>
                )

        }
    }

    const onCancel = ()=>{
        onClose()
        setSelectedConfig('BASIC DETAILS')
        setContentFilterName('')
        setContentFilterComment('')
        setBlockedCategories([])
        setAllowedDomains([])
        setBlockedDomains([])
    }

    const validateUniqueAllowedBlockedDomains = ()=>{
        let bIsUniue = true;
        for(let i=0;i<allowedDomains.length;i++){
            for(let j=i+1;j<allowedDomains.length;j++){
                if(allowedDomains[i].domain == allowedDomains[j].domain){
                    bIsUniue = false
                    break;
                }
            }
        }

        for(let i=0;i<blockedDomains.length;i++){
            for(let j=i+1;j<blockedDomains.length;j++){
                if(blockedDomains[i].domain == blockedDomains[j].domain){
                    bIsUniue = false
                    break;
                }
            }
        }

        for(let i=0;i<allowedDomains.length;i++){
            for(let j=0;j<blockedDomains.length;j++){
                if(allowedDomains[i].domain == blockedDomains[j].domain){
                    bIsUniue = false
                    break;
                }
            }
        }

        return bIsUniue
    }

    const onCreate = ()=>{
        let bIsUnique = validateUniqueAllowedBlockedDomains()
        if(!bIsUnique) {
            toast.error("Duplicate domains are present in allowed and blocked domains.", {
                position: toast.POSITION.BOTTOM_LEFT
            });
            return
        }

        let payload:OnSaveContentFilterParameters = {
            dp_id: authReducer.selectedOu.id,
            name: contentFilterName,
            description: contentFilterComment,
            categories: blockedCategories,
            allowed_domains:allowedDomains,
            blocked_domains: blockedDomains,
            enabled: true
        }
        onSave(payload)
    }

    const onEdit = ()=>{
        let bIsUnique = validateUniqueAllowedBlockedDomains()
        if(!bIsUnique) {
            toast.error("Duplicate domains are present in allowed and blocked domains.", {
                position: toast.POSITION.BOTTOM_LEFT
            });
            return
        }

        let payload:OnSaveContentFilterParameters = {
            dp_id: authReducer.selectedOu.id,
            id:contentFilterId,
            name: contentFilterName,
            description: contentFilterComment,
            categories: blockedCategories,
            allowed_domains:allowedDomains,
            blocked_domains: blockedDomains,
            enabled: true
        }
        onSave(payload)
    }

    useEffect(() => {
        if(!_.isEmpty(createContentFilterData) || !_.isEmpty(updateContentFilterData))
            if(createContentFilterData?.success == true || updateContentFilterData?.success == true){
                onCancel()
            }
    },[createContentFilterData, updateContentFilterData])

    const createDisabled = () => {
        if(contentFilterName && contentFilterComment && (blockedCategories.length > 0 || allowedDomains.length > 0 || blockedDomains.length > 0)) return false;
        else return true;
    }

    return (
        <div className="Form">
            <Dialog
                disableEnforceFocus
                open={open}
                scroll={scroll}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                className='config-create-content-filter-popup'
            >
            <div>
                <DialogTitle className='create-default-config-title'>
                        {!isEditContentFilter ? 
                            <span className="content-filter-title-name"> Create Content Filter </span>
                            :
                            <span className="content-filter-title-name"> Edit Content Filter </span>
                        }
                        <img src={close} title="Close" onClick={onCancel} className="create-content-filter-close-btn" />
                </DialogTitle>
                <DialogContent dividers={scroll ==='paper'} className='create-content-filter-dialog-content'>
                    <div className="form-content-filter">
                        <Grid container xs={12} sm={12} md={12} lg={12}>
                            <Grid item xs={3} sm={3} md={3} lg={3}>
                                <NavBar items={configItems} selectedItem={selectedConfig} onSelect={setSelectedConfig} />
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9}>
                                <div className="content-filter-config-details">
                                    {renderConfigForm()}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" className="content_filter--button_outlined_filter" onClick={onCancel}>
                        Cancel
                    </Button>
                    {
                        !isEditContentFilter ?
                            <Button variant="contained" className="content_filter-footer-create-button" onClick={onCreate} disabled={createDisabled()}>Create</Button>
                            :
                            <Button variant="contained" className="content_filter-footer-create-button" onClick={onEdit} disabled={defaultCF || createDisabled()}>Save</Button>
                    }
                </DialogActions>
            </div>
            </Dialog>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    customContentFilter: state.customContentFilter,
    createContentFilterData: state?.customContentFilter?.createContentFilter,
    updateContentFilterData: state?.customContentFilter?.updateCF
})

export default withRouter(
    connect(mapStateToProps, {
    })(CreateContentFilterDialog)
);  